<template>
  <ElDialog v-if="isModal" v-model="showSearch" :show-close="false" title="菜单搜索">
    <el-select
filterable :reserve-keyword="false" remote placeholder="请输入菜单内容" :remote-method="remoteMethod"
      style="width: 100%" @change="handleChange">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
  </ElDialog>
  <div v-else class="custom-hover router-search-top" @click.stop="toggleTopSearch">
    <Icon icon="ep:search" :color="color" />
    <el-select
ref="selectRef" @click.stop filterable :reserve-keyword="false" remote placeholder="请输入菜单内容"
      :remote-method="remoteMethod" class="overflow-hidden transition-all-600"
      :class="showTopSearch ? '!w-220px ml2' : '!w-0'" @change="handleChange">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
  </div>
</template>

<script lang="ts" setup>
import { propTypes } from '@/utils/propTypes'
defineProps({
  isModal: {
    type: Boolean,
    default: true
  },
  color: propTypes.string.def('')
})

const router = useRouter() // 路由对象
const showSearch = ref(false) // 是否显示弹框
const showTopSearch = ref(false) // 是否显示顶部搜索框
const selectRef = ref() // el-select 实例

// 点击图标展开/收起搜索框，展开后自动聚焦输入框
const toggleTopSearch = () => {
  showTopSearch.value = !showTopSearch.value
  if (showTopSearch.value) {
    nextTick(() => selectRef.value?.focus?.())
  }
}
const value: Ref = ref('') // 用户输入的值

const routers = router.getRoutes() // 路由对象
const options = computed(() => {
  // 提示选项
  if (!value.value) {
    return []
  }
  const list = routers.filter((item: any) => {
    const name = item.components?.default?.name
    if (name === 'Layout' || !(/^[\u4e00-\u9fa5]+$/.test(item.meta.title))) return false;
    if (item.meta.title?.indexOf(value.value) > -1) {
      return true
    }
  })
  return list.map((item) => {
    return {
      label: `${item.meta.title}`,
      value: item.path
    }
  })
})

function remoteMethod(data) {
  // 这里可以执行相应的操作（例如打开搜索框等）
  value.value = data
}

function handleChange(path) {
  router.push({ path })
  hiddenSearch()
  hiddenTopSearch()
}

function hiddenSearch() {
  showSearch.value = false
}

function hiddenTopSearch() {
  showTopSearch.value = false
}

onMounted(() => {
  window.addEventListener('keydown', listenKey)
  window.addEventListener('click', hiddenTopSearch)
})

onUnmounted(() => {
  window.removeEventListener('keydown', listenKey)
  window.removeEventListener('click', hiddenTopSearch)
})

// 监听 ctrl + k
function listenKey(event) {
  if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
    // 阻止触发浏览器默认事件
    event.preventDefault()
    showSearch.value = !showSearch.value
    // 这里可以执行相应的操作（例如打开搜索框等）
  }
}

defineExpose({
  openSearch: () => {
    showSearch.value = true
  }
})
</script>

<style scoped>
/* 头部展开的搜索框：灰底、无边框、圆角（与顶部搜索框风格一致） */
.router-search-top {
  :deep(.el-select__wrapper) {
    background-color: #f5f7fa !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 20px !important;
  }
}
</style>
